import { assign, NonReducibleUnknown, sendParent } from 'xstate';
import { SendChildMachineReady } from '../..';
import { FraudAlloyContext } from './fraudAlloyMachine';
import { InitializingNeuroIdResult } from './types/actors';
import { FraudAlloyMachineEvents } from './types/events';

/**
 * Assigns neuroIdTokens to context for event `SEND_INITIALIZE_NEURO_ID`
 */
export const assignNeuroIdTokens = assign<
  FraudAlloyContext,
  FraudAlloyMachineEvents,
  InitializingNeuroIdResult,
  FraudAlloyMachineEvents,
  never
>({
  neuroIdTokens: (_, params) => {
    return params.neuroIdTokens;
  },
});

/**
 * Sends create virtual card issuance attempting event to parent
   @returns SendCreateVirtualCardIssuanceAttempting
 */
export const emitFraudAlloyMachineReady = sendParent<
  FraudAlloyContext,
  FraudAlloyMachineEvents,
  NonReducibleUnknown,
  SendChildMachineReady,
  FraudAlloyMachineEvents,
  never,
  never
>(() => {
  return {
    type: 'SEND_CHILD_MACHINE_READY',
    params: {
      machineId: 'fraudAlloyMachine',
    },
  };
});
